import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "utils/base-query";

export const orderService = createApi({
  reducerPath: "orderService",
  baseQuery,
  tagTypes: ["ORDER"],
  endpoints: (builder) => ({
    updateCancelledStatus: builder.mutation({
      query: ({ orderId, cancelledFromDFY }) => ({
        url: `/admin/cancelled-from-dfy/${orderId}`,
        method: "PUT",
        body: { cancelledFromDFY },
      }),
      invalidatesTags: ["ORDER"],
    }),
  }),
});

export const { useUpdateCancelledStatusMutation } = orderService;
